import { InfoCircleOutlined } from '@ant-design/icons'
import { Modal } from 'antd'

import Box from '~/core/Box'
import Text from '~/core/Text'
import Button from '~/core/Button'
import getColor from '~/lib/getColor'

const PLACEMENT = 'user-profile-unsaved-warning-modal'

type WarningModalPropsType = {
    visible: boolean
    onClose: () => void
    onConfirm?: () => void
    loading?: boolean
}

export default function WarningModal(props: WarningModalPropsType) {
    const { visible, onClose, onConfirm, loading } = props

    return (
        <Modal
            bodyStyle={{ padding: '24px 12px 12px 24px' }}
            centered
            closable={false}
            footer={null}
            visible={visible}
            onCancel={onClose}
            width="348px"
            maskClosable
        >
            <Box>
                <InfoCircleOutlined
                    style={{
                        color: getColor('warning'),
                        fontSize: '21px',
                        marginRight: '18px',
                    }}
                />
                <Box direction="col" flex="1">
                    <Text
                        fontSize="16px"
                        color="blackAlpha65"
                        style={{ marginBottom: '16px' }}
                    >
                        You have unsaved changes.
                    </Text>
                    <Text
                        color="blackAlpha65"
                        style={{
                            marginBottom: '16px',
                        }}
                    >
                        Do you want to discard or save them?
                    </Text>
                    <Box justifyContent="end">
                        <Button
                            onClick={onClose}
                            name={`${PLACEMENT}-cancel`}
                            placement={PLACEMENT}
                            data-test-target={`${PLACEMENT}-cancel`}
                            style={{ marginRight: '8px', marginLeft: 'auto' }}
                        >
                            No, discard
                        </Button>
                        <Button
                            type="primary"
                            loading={loading}
                            disabled={loading}
                            onClick={onConfirm}
                            name={`${PLACEMENT}-save`}
                            placement={PLACEMENT}
                            data-test-target={`${PLACEMENT}-save`}
                        >
                            Yes, save
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    )
}
